var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedHelpInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.585,
    height: 28.585,
    rx: 14.293,
    fill: "#FFEDE8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#need-help-info-icon_svg__clip0_8406_23018)",
    stroke: "#E95832",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.293 20.96c3.451 0 6.25-2.985 6.25-6.667s-2.799-6.667-6.25-6.667c-3.452 0-6.25 2.985-6.25 6.667s2.798 6.666 6.25 6.666zM14.293 16.96v-2.667M14.293 11.626h.006"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "need-help-info-icon_svg__clip0_8406_23018"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.793 6.293)",
    d: "M0 0h15v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/need-help-info-icon.12baedba.svg";
export { SvgNeedHelpInfoIcon as ReactComponent };